export function getPublishableKey(customerId, providerHasRevenue) {
  // const customerId = localStorage.getItem("customer_id");
  // const providerHasRevenue = localStorage.getItem("provider_has_revenue") == "true";
  const isProduction = process.env.VUE_APP_ENV === "production";
  const testCustomerId = [999997,25844,29520, 29818, 30450,31157, 1000002];
  if (isProduction) {
    if (providerHasRevenue) {
      if (!testCustomerId.includes(customerId)) {
        return process.env.VUE_APP_STRIPE_MARKUP_PRODUCTION_KEY;
      } else {
        return process.env.VUE_APP_STRIPE_MARKUP_SANDBOX_KEY;
      }
    } else {
      if (!testCustomerId.includes(customerId)) {
        return process.env.VUE_APP_STRIPE_PRODUCTION_KEY;
      } else {
        return process.env.VUE_APP_STRIPE_SANDBOX_KEY;
      }
    }
  } else {
    return providerHasRevenue
      ? process.env.VUE_APP_STRIPE_MARKUP_SANDBOX_KEY
      : process.env.VUE_APP_STRIPE_SANDBOX_KEY;
  }
}
